import styled from "styled-components";

export const CustomInputWrapper = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  gap: 12px;
  position: relative;

  img {
    position: absolute;
    bottom: 11px;
    right: 10px;
  }
`;
